module.exports = __webpack_public_path__ + "img/kv-l.3d9e9df0.png";